import {  NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeLayoutComponent } from './layout/home-layout/home-layout.component';
import { PagesLayoutComponent } from './layout/pages-layout/pages-layout.component';
import { ArchiveComponent } from './modules/archive/archive.component';
import { HomeComponent } from './modules/home/home.component';
import { PagesComponent } from './modules/pages/pages.component';
import { SliderDetayComponent } from './modules/slider-detay/slider-detay.component';



const routes: Routes = [
 
  {
     path:':language', 
     component:HomeLayoutComponent, 
     children:[
          {path:'',component:HomeComponent},
          {path:'archive', component:ArchiveComponent},
          {path:'', component:PagesLayoutComponent, children:[
             {path:'pages/:category/:title',component: PagesComponent},
             {path:'slider/:sliderId/:title',component: SliderDetayComponent}

         ]},  

     ],    
  },
   {  path:'',   component:HomeLayoutComponent ,
        children:[
                {path:'', component:HomeComponent}     
          ],  
   }


];

@NgModule({
  declarations: [     
    
  ],
  
  imports: [RouterModule.forRoot(routes, {useHash:true} )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
